import { circuitBreaker } from "@/global";
import { EventSourcePolyfill } from "event-source-polyfill";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/`;

const connect = async (path: string, token: string) => {
  const url = `${baseURL}${path}`;

  return circuitBreaker(() => {
    return new Promise<EventSourcePolyfill>((resolve, reject) => {
      const eventSource = new EventSourcePolyfill(url, {
        headers: {
          "Consumer-Key": import.meta.env.VITE_CONSUMER_KEY_HEADER,
          Authorization: `Bearer ${token}`,
          "api-key": import.meta.env.VITE_TENANT_API_KEY,
          "Content-Type": "application/json",
          "SOURCE-SYSTEM": "STANDALONE_PLATFORM"
        }
      });

      eventSource.onopen = () => resolve(eventSource);
      eventSource.onerror = (error) => {
        eventSource.close();
        reject(new Error(error.message || "EventSource connection failed"));
      };
    });
  });
};

export default { connect };
